<div class="contact mb-30" *ngIf="content.slice(0, itemsToShow).length > 0">
    <div class="pb-12">
        <span class="content-type-text">
          {{ contentType === 'CONTACT' ? ('content_modal.contact' | translate)
            : contentType === 'SOCIAL_MEDIA' ? ('content_modal.social_media' | translate)
            : contentType === 'PAYMENT' ? ('content_modal.payment' | translate)
            : contentType === 'DOCUMENT' ? ('content_modal.documents' | translate)
            : contentType === 'BUSINESS' ? ('content_modal.business' | translate)
            : (contentType | titlecase) }}
        </span>
    </div>
    <div class="test-div" >
        <mat-grid-tile-header (click)="openAddContent(contents)" [ngClass]="isOverLimit(contents) ? 'disabled-button' : '' " class="big-div-style" *ngFor="let contents of content.slice(0, itemsToShow)">
            <div class="single-link-style" >
                <div class="avatar size-fixed text-style avatar-lg mr-2">
                    <img [src]="contents.contentIcon ? getContentImage(contents.contentIcon) : '' " class="avatar-img" alt="Image"/>
                    <span class="payment_title">{{ contents.name }}</span>
                </div>
                <div class="plus-button">
                    <img src="assets/svg/plus.svg">
                </div>
            </div>
        </mat-grid-tile-header>
      <div *ngIf="content.length > 12" class="see-more d-flex justify-content-end w-100" (click)="toggleShowMore()">
        <span>{{ showMore ? ('search.see_less' | translate) : ('search.see_more' | translate) }}</span>
      </div>
    </div>
</div>
